import { sva } from '@agapi/ui/panda/css';
import { anatomy } from '@zag-js/combobox';
export const comboboxStyles = sva({
    slots: [...anatomy.keys()],
    base: {
        root: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            gap: '3'
        },
        control: {
            position: 'relative',
            gap: '3'
        },
        trigger: {
            position: 'absolute',
            right: '3',
            top: '0',
            bottom: '0',
            p: '2',
            cursor: 'pointer'
        },
        input: {
            border: '1px solid #ccc',
            padding: '8px',
            borderRadius: 'forms',
            width: '100%'
        },
        item: {
            padding: '8px',
            borderRadius: 'forms',
            cursor: 'pointer',
            _hover: {
                backgroundColor: 'grey.100'
            },
            '&[data-highlighted]': {
                backgroundColor: 'surface.primary.subdued.background'
            }
        },
        content: {
            backgroundColor: 'white',
            borderRadius: 'forms',
            borderWidth: '1px',
            borderColor: 'borders.base',
            cursor: 'pointer',
            maxHeight: 'var(--available-height)',
            overflowY: 'scroll'
        },
        positioner: {
            zIndex: '999!'
        }
    }
});
